// side-navigation-menu.component.ts
import { Component } from '@angular/core';
import { NgIf } from '@angular/common';
import { SidebarService } from '../../shared/services/sidebar.service'; // Adjust the path as needed
import { RouterModule, Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { AuthService } from '../../shared/services';
import { SageIntegrationService } from '../../../shared/services/sage-integration.service';
import { canUseSage } from '../../../shared/services/sage-integration.model';

@Component({
  selector: 'app-side-navigation-menu',
  standalone: true,
  imports: [NgIf,RouterModule],
  templateUrl: './side-navigation-menu.component.html',
  styleUrls: ['./side-navigation-menu.component.css']
})
export class SideNavigationMenuComponent {
  sidebarExpanded = false;
  SWITCH = false; // Used to toggle the SVG icon
  currentTheme: 'light' | 'dark' = 'light';
  tenantName: any;
  fullName: any;
  userRole: any;
  showSage = false;
  accountType: string = 'full';
  sageReviewCount = 0;


  constructor(private sidebarService: SidebarService,private router: Router,private authService: AuthService,private sageService: SageIntegrationService) {
    // Subscribe to sidebar state changes

    this.sidebarService.isExpanded$.subscribe(expanded => {
      this.sidebarExpanded = expanded;
    });

    this.sageService.reviewCount$.subscribe((count: number) => {
      this.sageReviewCount = count;
    });

    // Initialize theme from localStorage
    const savedTheme = localStorage.getItem('theme') as 'light' | 'dark';
    if (savedTheme) {
      this.currentTheme = savedTheme;
      document.documentElement.setAttribute('data-bs-theme', this.currentTheme);
    }
  }
ngOnInit(): void {
  const JWT = localStorage.getItem('authToken');
  if (!JWT) { return; }
  try {
    const decodedToken: any = jwtDecode(JWT);
    this.tenantName = decodedToken.TenantName;
    this.fullName = decodedToken.FullName;
  } catch { /* invalid token — leave fields blank */ }
  this.userRole = this.authService.getUserRole();
  this.showSage = canUseSage(this.userRole);
  this.accountType = this.authService.getAccountType();
}
  toggleSidebar(): void {
    this.sidebarService.toggleSidebar();
    this.SWITCH = !this.SWITCH;
  }

  toggleTheme(): void {
    this.currentTheme = this.currentTheme === 'light' ? 'dark' : 'light';
    document.documentElement.setAttribute('data-bs-theme', this.currentTheme);
    localStorage.setItem('theme', this.currentTheme);
  }
  async logout(): Promise<void> {
    if (this.sidebarExpanded) {
      this.sidebarService.toggleSidebar();
    }
    await this.authService.logOut();
  }
}
